var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('Breadcrumbs',{attrs:{"links":_vm.links}}),_vm._v("\n    Divisions admin page\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }